import { render, staticRenderFns } from "./DepartUserList.vue?vue&type=template&id=0bbf96f3&scoped=true&"
import script from "./DepartUserList.vue?vue&type=script&lang=js&"
export * from "./DepartUserList.vue?vue&type=script&lang=js&"
import style0 from "./DepartUserList.vue?vue&type=style&index=0&id=0bbf96f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf96f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbf96f3')) {
      api.createRecord('0bbf96f3', component.options)
    } else {
      api.reload('0bbf96f3', component.options)
    }
    module.hot.accept("./DepartUserList.vue?vue&type=template&id=0bbf96f3&scoped=true&", function () {
      api.rerender('0bbf96f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DepartUserList.vue"
export default component.exports